const PROJECT_NAME = process.env.REACT_APP_FIREBASE_PROJECT_ID

export const SERVER_URL = `https://us-central1-${PROJECT_NAME}.cloudfunctions.net`
